import { Button, Card, CardContent, CircularProgress, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Apiurl } from "../api_urls";
import { loginuser } from "../redux_store/LoginSlice";
import { useDispatch } from "react-redux";
import { GToaster } from "./g_toaster";
import { riderlogin } from "../redux_store/RiderloginSlice";


const toster = new GToaster()
function TngLogin() {


    const [btnloader, setbtnloader] = useState(false)
    const [driver, setdriver] = useState(false);
    const url = Apiurl.USER_LOGIN_URL
    const navi = useNavigate()
    const dispatch = useDispatch()
    async function submitdata(e) {
        e.preventDefault()
        let data = new FormData(e.currentTarget)
        let n = data.get("name")
        let phone = data.get("phone")
        let obj = { mobile: phone }
        localStorage.removeItem("persist:root")
        setbtnloader(true)
        // console.log(n,phone)

        if (n == "mukesh") {

            if (driver) {
    setbtnloader(true);

    try {
        const response = await axios.post(Apiurl.DRIVER_LOGIN_URL, obj);

        switch (response.status) {
            case 200:
                localStorage.setItem("access_token", response.data.access_token);
                localStorage.setItem("role", response.data.data.role);
                dispatch(riderlogin(response.data.data));
                toster.success({ title: "Login Successfully" });
                navi("/riderprofile");
                break;

            case 202:
                toster.warning({
                    title: "Your account status is inactive. Please contact the admin."
                });
                break;

            default:
                toster.error({
                    title: "Something went wrong in login user"
                });
        }
    } catch (err) {
        if (err.response?.status === 300) {
            toster.warning({
                title: "This contact no. is not registered. Please check your contact."
            });
        } else {
            toster.error({
                title: "Something went wrong in login user"
            });
        }
    } finally {
        setbtnloader(false);
    }
}else {

                setbtnloader(false);

axios.post(url, obj)
    .then((response) => {

        if (response.status === 200) {
            localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("role", response.data.data.role);
            if (response.data.data.status === 0) {
                alert("Your account status is inactive. Please contact the admin");
            } else {
                dispatch(loginuser(response.data.data));
                alert("Login Success");
                navi("/mybookings");
            }
        }

    })
    .catch((err) => {

        if (err.response?.status === 400) {
            alert("This contact no. is not registered. Please check your contact.");
        } else {
            alert("Something went wrong.");
        }

        console.log(err);
    })
    .finally(() => {
        setbtnloader(false);
    });
            }
        } else {
            alert("you are not authorised this is for admin use")
            setbtnloader(true)
        }
    }

    return (
        <>

            <Grid container spacing={1} sx={{ m: "auto" }}>
                <Grid item xs={10} sm={6} md={5} sx={{ m: "auto", mt: 20 }}>
                    <Card>
                        <CardContent>
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", py: 1 }}>
                                <Button variant="contained" color="primary" onClick={() => setdriver(true)}>Rider login</Button>
                                <Button variant="contained" color="secondary" onClick={() => setdriver(false)}>Passanger</Button>
                            </Grid>

                            <Typography variant="h5" sx={{ p: 2 }}>Tng login form </Typography>
                            <form onSubmit={submitdata}>
                                <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth name="name" placeholder="name" required />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth name="phone" placeholder={driver ? "Rider Phone" : "User Phone"} required />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {btnloader ? <CircularProgress /> : <Button fullWidth variant="contained" type="submit">submit</Button>}
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>



        </>
    )


}


export default TngLogin